export default __webpack_public_path__ + "static/media/PrintRuleBackSideA6.7f9ed22e.svg";